import {
    AnyAction,
    Middleware,
    MiddlewareAPI,
    ThunkDispatch,
} from '@reduxjs/toolkit'
import {NinchatEventType} from '../../api/types/events'
import {NinchatMessages} from '../../api/types'
import {RootState} from 'store'
import {describeFile} from 'api/action/describeFile'
import {loadHistory} from '../../api/action/loadHistory'
import {messageReceived} from '../../api/event/messageReceived'

type AsyncThunkDispatch = ThunkDispatch<RootState, undefined, AnyAction>

export const eventMiddleware: Middleware = (store: MiddlewareAPI<AsyncThunkDispatch>) => (next) => (action) => {
    const {dispatch} = store

    switch (action.type) {
        case loadHistory.fulfilled.type:
        case messageReceived.fulfilled.type: {
            const result = next(action)

            const payloads = Array.isArray(action.payload) ? action.payload : [action.payload]

            for (const payload of payloads) {
                const isMessageReceived = typeof payload === 'object' && payload.event.event === NinchatEventType.NinchatMessageReceivedEvent

                if (isMessageReceived && payload.event.message_type === NinchatMessages.NinchatMessageTypes.NinchatFileMessage) {
                    const {
                        event,
                        payload: {files},
                    } = payload

                    for (const {file_id} of files) {
                        dispatch(describeFile({
                            event,
                            file_id,
                        }))
                            .unwrap()
                            .then(
                                null,
                                () => undefined,
                            )
                    }
                }
            }

            return result
        }
        default:
            return next(action)
    }
}
